import React from 'react';
import tickIcon from '../img/tickIcon.svg'

const ButtonC = (props) => {
  const mainBtnC = {
    background: props.btnBgClr,
    color: props.btnClr,
    height: props.btnHeight,
  };

  const isMultiLine = props.className && props.className.includes('mainBtnMultiLine');
  const wrapperClass = isMultiLine 
    ? 'd-flex align-items-center gap-1 justify-content-center' 
    : 'd-flex align-items-center gap-1 justify-content-center w-100';

  return (
    <div className={wrapperClass}>
      <button type="button" onClick={props.onClick} className={`flex_align mainBtn ${props.className}`} style={mainBtnC}>{props.btnTxt}</button>
      {props.submitIcon && <img src={tickIcon} alt="" />}
    </div>
  );
};

export default ButtonC;
